module.exports = __webpack_public_path__ + "static/media/burger-menu-close-icon.b0a294d0.svg";